import React from 'react';
import Slider, { ResponsiveObject } from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { FaArrowCircleLeft, FaArrowCircleRight } from 'react-icons/fa';

interface ISlider {
  autoplay?: boolean;
  speed?: number;
  slidesToShow?: number;
  slidesToScroll?: number;
  arrows?: boolean;
}

const SliderContainer: React.FC<ISlider> = ({
  
  speed = 2000,
  slidesToShow = 1,
  slidesToScroll = 1,
  arrows = true,
  children,
}) => {


  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
       
        onClick={onClick}
      >
        <FaArrowCircleLeft/>
        </div>
    );
  }

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
      
        onClick={onClick}
      >
        <FaArrowCircleRight/>
        </div>
    );
  }

  const settings = {
    infinite: true,
 arrows: true,
    speed,
    slidesToShow,
    slidesToScroll,
    dots : false,

    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
  
        },
      },
    ],
  };
  return <Slider  {...settings}>{children}</Slider>;
};

export default SliderContainer;
